import { TopBarBorder } from "@ui/components/TopBar/TopBarBorder";
import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";
import { PageFrame } from "@/layouts/page-frame";

const setupFrameStyles = tv({
  slots: {
    main: "flex flex-1 flex-col items-center px-4 py-6 sm:px-6 lg:px-8",
    content: "flex w-full max-w-screen-xl flex-1 flex-col items-center",
  },
});

export interface SetupFrameProps {
  children: ReactNode;
}

/**
 * Onboarding-style picker layout. Wraps `PageFrame` with the global app chrome stripped
 * back — no centre nav, no mobile tabs, no locale footer — so the page presents as a
 * single focused choice.
 *
 * Lives in `app/frontend/layouts/` because it composes the app-only `PageFrame`. Used
 * by `/accounts/new`.
 */
export function SetupFrame({ children }: SetupFrameProps) {
  const styles = setupFrameStyles();

  return (
    <PageFrame
      contentMaxWidth="full"
      contentPadded={false}
      hideBottomBar
      hideFooter
      hideTopBarNav
      topBarBottomContent={<TopBarBorder />}
    >
      <main className={styles.main()}>
        <div className={styles.content()}>{children}</div>
      </main>
    </PageFrame>
  );
}
